
export const dots = ['27 6', `
  <g>
  <path d="M3.21453 6C1.57274 6 0.241801 4.65685 0.241801 3C0.241801 1.34315 1.57274 0 3.21453 0C4.85632 0 6.18726 1.34315 6.18726 3C6.18726 4.65685 4.85632 6 3.21453 6Z" fill="#BDBDBD"/>
  <path d="M13.1237 6C11.4819 6 10.151 4.65685 10.151 3C10.151 1.34315 11.4819 0 13.1237 0C14.7655 0 16.0964 1.34315 16.0964 3C16.0964 4.65685 14.7655 6 13.1237 6Z" fill="#BDBDBD"/>
  <path d="M23.0326 6C21.3909 6 20.0599 4.65685 20.0599 3C20.0599 1.34315 21.3909 0 23.0326 0C24.6744 0 26.0054 1.34315 26.0054 3C26.0054 4.65685 24.6744 6 23.0326 6Z" fill="#BDBDBD"/>
  </g>
`]
